import { useClientPortalAPI } from "@certn/api/src/useClientPortalAPI";
import { Picker } from "@certn/cascadia-react";
import { useTranslation } from "react-i18next";

import { useQueryParams } from "../../../hooks/useQueryParams";

export function CheckTypeFilter() {
  const { setParam, params } = useQueryParams();
  const { t } = useTranslation();
  const { data: types, isLoading } = useClientPortalAPI(
    "/api/internal/client-portal/checks/types/",
    params.customer_group_id
      ? { customer_group_id: params.customer_group_id.split(",") }
      : {}
  );

  return (
    <Picker
      isLoading={isLoading}
      showActionBar
      selectedKeys={params.check_type?.split(",") || []}
      onSelectionChange={(keys) => setParam("check_type", Array.from(keys))}
      label={t("Check type")}
      items={types || []}
      selectionMode="multiple"
      testID="check-type-filter"
    />
  );
}
